export const SET_TOKEN = 'SET_TOKEN'
export const SET_NOW_SELECT_UUID = 'SET_NOW_SELECT_UUID'
export const SET_CONFIG_STATE = 'SET_CONFIG_STATE'
export const TRIGGER_INIT_PAGE_FUN = 'TRIGGER_INIT_PAGE_FUN'
export const SET_LANG_STATE = 'SET_LANG_STATE'
export const SET_MASK_STATUS = 'SET_MASK_STATUS'
export const SET_MENUS_STATUS = 'SET_MENUS_STATUS'
export const SET_MENUS = 'SET_MENUS'
export const SET_LEFT_MENUS = 'SET_LEFT_MENUS'
export const SET_MENUS_VALUE = 'SET_MENUS_VALUE'
export const SET_FETCH_STATUS = 'SET_FETCH_STATUS'
export const SET_ASSET_LIST_FOR_USER = 'SET_ASSET_LIST_FOR_USER'
export const SET_ASSET_LIST = 'SET_ASSET_LIST'
export const SET_LOADING = 'SET_LOADING'
export const SET_MAJOR_LIST = 'SET_MAJOR_LIST'
export const SET_GUIDE = 'SET_GUIDE'
export const SET_NAV_BAR = 'SET_NAV_BAR'
export const SET_HIDE_LEFT_MENUS = 'SET_HIDE_LEFT_MENUS'
export const SET_IS_MICRO = 'SET_IS_MICRO'
export const SET_IS_ASIDE_EXPAND = 'SET_IS_ASIDE_EXPAND'


